import { useState, useCallback, useEffect, useRef } from "react";
import Icon from "@mdi/react";
import { mdiInformationOutline } from "@mdi/js";
import "./TooltipInfo.scss";

const TooltipInfo = ({
  text,
  iconSize = 0.85,
  placement = "top",
  ariaLabel = "More info",
}) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  const toggle = useCallback(() => setVisible((prev) => !prev), []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setVisible(false);
      }
    };

    if (visible) {
      document.addEventListener("click", handleClickOutside, true);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [visible]);

  return (
    <div ref={ref} className={`tooltip-info tooltip-info--${placement}`}>
      <button
        type="button"
        className="tooltip-info__trigger"
        aria-label={ariaLabel}
        onClick={toggle}
      >
        <Icon path={mdiInformationOutline} size={iconSize} />
      </button>
      <div
        className={`tooltip-info__bubble ${visible ? "visible" : ""}`}
        role="tooltip"
      >
        {text}
      </div>
    </div>
  );
};

export default TooltipInfo;
